import { IHtmlTagConfig } from "./interfaces/IHtmlTagConfig";

export const emptyTagConfig: IHtmlTagConfig = {
    attributes: null,
    styles: null
};
